module.exports = __webpack_public_path__ + "img/monedas.7a482ab4.png";